import { getPlatforms } from '@ionic/vue';

export function usePlatforms() {
    const platforms = getPlatforms();

    const isMobileView = () => {
        return platforms.includes('mobile') || platforms.includes('android') || platforms.includes('ios');
    };

    return {
        isMobileView,
    };
}